import { Link, useParams } from 'react-router';

import { fetchSalesOrderDetail } from '#/api/crmMgmt/salesOrder/fetchDetail';
import { updateSalesOrderRemark } from '#/api/crmMgmt/salesOrder/updateRemark';
import { ROUTES } from '#/config/routes';
import useDocumentRemarkSave from '#/hooks/useDocumentRemarkSave';
import { Button } from '#/modules/commonComponents/button';
import SalesOrderMainInfoCard from '#/modules/crmMgmt/salesOrder/components/SalesOrderMainInfoCard';
import {
  getSalesOrderApiErrorMessage,
  isSalesOrderVersionConflict,
} from '#/modules/crmMgmt/salesOrder/helper/apiError';
import { canUpdateSalesOrderRemark } from '#/modules/crmMgmt/salesOrder/helper/salesOrderStatus';
import DocumentRemarkEditForm from '#/modules/imsMgmt/receipts/shared/DocumentRemarkEditForm';
import PageShell from '#/modules/infra/layout/PageShell';
import {
  salesOrderDetailQueryKey,
  salesOrderListQueryKeyPrefix,
} from '#/utils/queryKeys';

const SalesOrderRemarkPage = () => {
  const { id } = useParams();

  const {
    detail,
    detailQuery,
    isPending,
    saveRemark,
  } = useDocumentRemarkSave({
    id,
    fetchDetail: fetchSalesOrderDetail,
    updateRemark: updateSalesOrderRemark,
    detailQueryKey: salesOrderDetailQueryKey,
    listQueryKeyPrefix: salesOrderListQueryKeyPrefix,
    getErrorMessage: (error) => getSalesOrderApiErrorMessage(error, '更新備註失敗'),
    isVersionConflict: isSalesOrderVersionConflict,
    afterSaveNavigateTo: ROUTES.salesOrderDetail(id),
  });

  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;
  const remarkAllowed = detail ? canUpdateSalesOrderRemark(detail.status) : false;

  return (
    <PageShell variant="form">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">編輯銷貨單備註</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.salesOrderDetail(id)}>返回詳情</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getSalesOrderApiErrorMessage(detailQuery.error, '找不到銷貨單')}
            </p>
          ) : null}

          {detail && !remarkAllowed ? (
            <p className="text-sm text-slate-600">目前狀態不可編輯備註。</p>
          ) : null}

          {detail && remarkAllowed ? (
            <>
              <SalesOrderMainInfoCard detail={detail} />
              <DocumentRemarkEditForm
                initialRemark={detail.remark ?? ''}
                cancelTo={ROUTES.salesOrderDetail(id)}
                isPending={isPending}
                onSave={saveRemark}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default SalesOrderRemarkPage;
